module.exports = __webpack_public_path__ + "img/elo.b5640645.png";